import {useEffect, useState} from "react";
import {
    RefreshIcon,
    ToolboxBtn,
    ToolboxItemBox,
    ToolboxToggleIcon,
    ToolboxToggleWrapper,
    ToolboxWrapper
} from "../../styles/dashboard";
import {DText, Flex} from "../../styles/MarketStyles";
import Text from "../../utils/Text";
import Toggle from "../common/buttons/Toggle";


const Toolbox = (props) => {

    const {
        items,
        onStateChange,
        options,
        onOptionsChange,
        onSave,
        onCancel,
        onReset
    } = props

    const [open, setOpen] = useState(true)
    const [toolboxItems, setToolboxItems] = useState([])

    useEffect(() => {
        let box = []
        for (let i = 0; i < items.length; i+=2) {
            const item = {
                first: items[i],
                second: items[i+1]
            }
            box.push(item)
        }
        setToolboxItems(box)
    }, [items])

    const onFullscreenChange = () => {
        onOptionsChange(!options.fullscreen, 'fullscreen')
    }

    return (
        <>
            <ToolboxWrapper
                open={open}
            >
                <Flex fw fh>
                    <Flex width={'70%'} fh justify={'space-between'} wrap>
                        {toolboxItems.map((item, idx) => (
                            <ToolboxItemBox>
                                <ToolboxItem
                                    item={item.first}
                                    onStateChange={() => onStateChange(idx * 2)}
                                />
                                <ToolboxItem
                                    item={item.second}
                                    onStateChange={() => onStateChange(idx * 2 + 1)}
                                />
                            </ToolboxItemBox>
                        ))}
                    </Flex>
                    <Flex width={'30%'} fh justify={'flex-end'} wrap>
                        <ToolboxBtn onClick={onFullscreenChange}>
                            <Text tid={options.fullscreen ? 'classic' : 'fullscreen'} />
                        </ToolboxBtn>
                        <ToolboxBtn submit onClick={onSave}>
                            <Text tid={'save'} />
                        </ToolboxBtn>
                        <ToolboxBtn cancel onClick={onCancel}>
                            <Text tid={'cancel'} />
                        </ToolboxBtn>
                        <RefreshIcon size={18} onClick={onReset}/>
                    </Flex>
                </Flex>
            </ToolboxWrapper>
            <div style={{ position: "relative", width: '100%' }}>
                <ToolboxToggleWrapper open={open} onClick={() => setOpen(state => !state)}>
                    <ToolboxToggleIcon size={18} open={open} />
                </ToolboxToggleWrapper>
            </div>
        </>
    )
}

const ToolboxItem = (props) => {

    const { item, onStateChange } = props
    return (
        <Flex fw justify={'space-between'} style={{ margin: '2px 0' }}>
            <DText fontSize={'s'} primary>
                <Text tid={item.name} />
            </DText>
            <Toggle
                style={{ margin: '0 8px' }}
                isActive={item.active}
                onChange={onStateChange}
            />
        </Flex>
    )
}

export default Toolbox
